class RelanceFactureModel {
    constructor(data) {
        // Facture
        this.facture = {
            id: data.facture?.id || null,
            numero: data.facture?.numero || null,
            total_centimes: data.facture?.total_centimes || 0,
            devise: data.facture?.devise || "EUR",
            statut: data.facture?.statut || null,
            client: {
                id: data.facture?.client?.id || null,
                nom_affichage: data.facture?.client?.nom_affichage || "",
                email: data.facture?.client?.email || "",
                telephone: data.facture?.client?.telephone || "",
            },
        };

        // Relances
        this.relances = (data.relances || []).map((r) => ({
            id: r.id || null,
            message: r.message || "",
            date_relance: r.date_relance || null,
            title: r.title || null,
            subject: r.subject || null,
        }));
    }
}

export default RelanceFactureModel;
